function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.2742 7.84912L27.5625 6.13745L25.8508 7.84912L25.0554 7.05371L27.5625 4.54663L30.0696 7.05371L29.2742 7.84912Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 5.62329H28.125V11.8108H27V5.62329Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.375 19.1234H29.25V16.7044C33.494 15.8382 36.3928 11.899 35.9572 7.58936C35.5218 3.27997 31.8941 0 27.5625 0C23.2309 0 19.6032 3.27997 19.1678 7.58936C18.7322 11.899 21.631 15.8382 25.875 16.7044V19.1234H24.75V34.8734H22.5V16.8734H16.875V34.8734H14.625V21.3734H9V34.8734H6.75V26.9984H1.125V34.8734H0V35.9984H36V34.8734H30.375V19.1234ZM5.625 34.8734H2.25V28.1234H5.625V34.8734ZM13.5 34.8734H10.125V22.4984H13.5V34.8734ZM21.375 34.8734H18V17.9984H21.375V34.8734ZM20.25 8.43585C20.25 4.53296 23.3149 1.31808 27.2134 1.13187C31.1116 0.945374 34.4693 3.85345 34.8418 7.73822C35.2139 11.6233 32.4698 15.1161 28.607 15.6734L28.125 15.7426V19.1234H27V15.7426L26.518 15.6734C22.9276 15.1403 20.2648 12.0655 20.25 8.43585ZM29.25 34.8734H25.875V20.2484H29.25V34.8734Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.75 8.43579C33.75 5.01849 30.9798 2.24829 27.5625 2.24829C24.1452 2.24829 21.375 5.01849 21.375 8.43579C21.375 11.8531 24.1452 14.6233 27.5625 14.6233C30.9781 14.6192 33.7459 11.8514 33.75 8.43579ZM22.5 8.43579C22.5 5.63977 24.7665 3.37329 27.5625 3.37329C30.3585 3.37329 32.625 5.63977 32.625 8.43579C32.625 11.2315 30.3585 13.4983 27.5625 13.4983C24.7679 13.495 22.503 11.2304 22.5 8.43579Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.09497 19.1233H12.0454L16.875 14.2937V15.7483H18V12.3733H14.625V13.4983H16.0796L11.5796 17.9983H7.65497L0.18042 24.8977L0.944519 25.7236L8.09497 19.1233Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.625 19.1233H36V20.2483H32.625V19.1233Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.625 21.3733H36V22.4983H32.625V21.3733Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.625 23.6233H36V24.7483H32.625V23.6233Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.625 25.8733H36V26.9983H32.625V25.8733Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.625 28.1233H36V29.2483H32.625V28.1233Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.625 30.3733H36V31.4983H32.625V30.3733Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.625 32.6233H36V33.7483H32.625V32.6233Z",
  fill: "#AFAFAF"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "white"
})));
function SvgSearchEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEngine);
export default __webpack_public_path__ + "static/media/search-engine.4332b959ca3774ba0ae458b7d26a5845.svg";
export { ForwardRef as ReactComponent };